import type { Room } from "@eisox/api/core-api";

export type RoomDeletionBlocker = "valves" | "multisensors" | "airHandlerUnits";

interface GetRoomDeletionBlockersParams {
  room: Pick<Room, "airHandlerUnitIds">;
  valves: unknown[];
  multisensors: unknown[];
}

/** Reasons the back would refuse to delete the room; an empty list means the room is deletable. */
export const getRoomDeletionBlockers = ({
  room,
  valves,
  multisensors,
}: GetRoomDeletionBlockersParams): RoomDeletionBlocker[] => [
  ...(valves.length > 0 ? (["valves"] as const) : []),
  ...(multisensors.length > 0 ? (["multisensors"] as const) : []),
  ...(room.airHandlerUnitIds.length > 0 ? (["airHandlerUnits"] as const) : []),
];
